import {useEffect} from 'react';
import {Outlet} from 'react-router';
import {startupProfiler} from '../common/utils/startupProfiler';
import {useAppLoading} from '../main/hooks/useAppLoading';
import {ComponentWithoutChildren} from '../react/types';

export const PublicOutlet: ComponentWithoutChildren = () => {
  const {isAppLoading, setAppLoading} = useAppLoading();

  useEffect(() => {
    if (isAppLoading) {
      startupProfiler.mark('Public Route Outlet Mounted');
      setAppLoading(false);
    }
  }, [isAppLoading, setAppLoading]);

  return <Outlet />;
};
